import { t } from "@/i18n-js/instance";
import { useBoolean } from "@circle-react/hooks/utils/useBoolean";
import { ThreeDotsDropdownV3 } from "@circle-react-shared/ThreeDotsDropdownV3";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { Settings } from "./Settings";

export const SettingsAction = () => {
  const [isSettingsOpen, toggleSettingsOpen] = useBoolean(false);
  return (
    <>
      <ThreeDotsDropdownV3 label={t("space_settings")}>
        <Dropdown.ItemLink forceClose onClick={toggleSettingsOpen}>
          {t("sidebar_settings")}
        </Dropdown.ItemLink>
      </ThreeDotsDropdownV3>
      <Settings open={isSettingsOpen} onClose={toggleSettingsOpen} />
    </>
  );
};
